import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

/** Una comisión ya registrada. Dos orígenes con forma ligeramente distinta:
 *  `operacion` (cierre de deal) trae `contrato` + `property_id`; `servicio`
 *  (comisión de socio de un lead) trae `service_id`. Ambos comparten lo demás.
 *  `importe` es entero (euros); `mes` es AAAA-MM; `created_at` es un unix ts en
 *  string (así lo escribe el backend). */
export interface Comision {
  commission_id: string;
  origen: 'operacion' | 'servicio';
  ref: string;
  concepto: string;
  importe: number;
  mes: string;
  created_at: string;
  client_id?: string;
  contrato?: string;
  property_id?: string;
  service_id?: string;
}

/** Lee CommissionsTable. La escriben cerrar_deal y registrar_comision_servicio;
 *  aquí solo se lee. El backend ya ordena por fecha (reciente primero). */
export function useCommissions() {
  return useQuery<Comision[]>({
    queryKey: ['commissions'],
    queryFn: async () => (await api.get('/crm/commissions')).data.items,
  });
}
